export const environment = {
  production: true,
  baseApi: 'https://generic.s132-148-80-100.com/index.php',
  baseUrl: 'https://variations.s132-148-80-100.com/',
  baseApiVariations: 'https://api-dco.ads-previews.com/public',
  key: '-o?TVtr696O%(=*zM/n'
};
